import { render, staticRenderFns } from "./ClinicInfo.vue?vue&type=template&id=d443588c&scoped=true"
import script from "./ClinicInfo.vue?vue&type=script&lang=js"
export * from "./ClinicInfo.vue?vue&type=script&lang=js"
import style0 from "./ClinicInfo.vue?vue&type=style&index=0&id=d443588c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d443588c",
  null
  
)

export default component.exports